const isDuplicated = (items) => new Set(items).size !== items.length;

const areArrayOfIdsEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const listIds1 = arr1.map(({ id }) => id);
  const listIds2 = arr2.map(({ id }) => id);

  if (isDuplicated(listIds1) || isDuplicated(listIds2)) {
    return false;
  }

  return arr1
    .map(({ id: id1, weightage: weightage1 }) => {
      const foundItemFromArr2 = arr2.find(({ id: id2 }) => id1 === id2);

      if (!foundItemFromArr2) {
        return false;
      }

      return foundItemFromArr2.weightage === weightage1;
    })
    .every((isEqual) => isEqual);
};

export default areArrayOfIdsEqual;
